import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../apiClient';

export default function BannerCarousel() {
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [idx, setIdx] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    api.get('/banners').then((r) => setBanners(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (banners.length < 2) return;
    timerRef.current = setInterval(() => {
      setIdx((prev) => (prev + 1) % banners.length);
    }, 4500);
    return () => clearInterval(timerRef.current);
  }, [banners.length]);

  const onPress = useCallback((b) => {
    if (b.link_type === 'external_url') window.open(b.link_target, '_blank');
    else if (b.link_type === 'event') navigate(`/event/${b.link_target}`);
    else if (b.link_type === 'category') navigate(`/search?category=${b.link_target}`);
  }, [navigate]);

  if (banners.length === 0) return null;

  return (
    <div className="mt-4 px-6">
      <div className="relative overflow-hidden rounded-2xl h-[180px] cursor-pointer shadow-sm">
        {banners.map((b, i) => (
          <button
            key={b.id}
            data-testid={`banner-${b.id}`}
            onClick={() => onPress(b)}
            className={`absolute inset-0 w-full h-full transition-opacity duration-500 ${i === idx ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
          >
            <img src={b.image_url} alt={b.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/35" />
            <span className="absolute bottom-4 left-5 right-5 text-white text-lg font-black tracking-tight text-left line-clamp-2">
              {b.title}
            </span>
          </button>
        ))}
      </div>
      {banners.length > 1 && (
        <div className="flex justify-center gap-1 mt-2">
          {banners.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all duration-300 ${i === idx ? 'w-5 bg-brand-magenta' : 'w-1.5 bg-gray-300'}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
